import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CONTACT_INFO } from '../config';
import './Header.css';

function Header({ config }) {
  const [searchQuery, setSearchQuery] = useState('');
  const [isNavOpen, setIsNavOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/search?q=${encodeURIComponent(searchQuery)}`);
    }
  };

  return (
    <header className="site-header">
      {/* Top Bar */}
      <div className="top-bar d-none d-lg-block">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <div className="top-info">
              <span><i className="bi bi-envelope me-2"></i>contact@{window.location.hostname}</span>
              <span className="ms-4"><i className="bi bi-telephone me-2"></i>{CONTACT_INFO.phone}</span>
            </div>
            <div className="top-links">
              <Link to="/about">About</Link>
              <Link to="/faq">FAQ</Link>
              <Link to="/contact">Contact</Link>
            </div>
          </div>
        </div>
      </div>

      {/* Main Header */}
      <nav className="navbar navbar-expand-lg navbar-dark main-nav">
        <div className="container">
          <Link to="/" className="navbar-brand">
            {config.logo ? (
              <img src={config.logo} alt={config.name} className="logo-image" />
            ) : (
              <div className="brand-text">
                <span className="brand-name">{config.name}</span>
                <span className="brand-tagline">{config.tagline}</span>
              </div>
            )}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            onClick={() => setIsNavOpen(!isNavOpen)}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className={`collapse navbar-collapse ${isNavOpen ? 'show' : ''}`}>
            {/* Search Form */}
            <form className="search-form mx-auto" onSubmit={handleSearch}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search products, categories..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button className="btn btn-light" type="submit">
                  <i className="bi bi-search"></i>
                </button>
              </div>
            </form>

            {/* Navigation Links */}
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <Link to="/" className="nav-link">
                  <i className="bi bi-house-door me-1"></i>Home
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/categories" className="nav-link">
                  <i className="bi bi-grid me-1"></i>Categories
                </Link>
              </li>
              <li className="nav-item">
                <Link to="/contact" className="nav-link">
                  <i className="bi bi-envelope me-1"></i>Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
